import Header from '../header/header';
import Container from '../Container';
import Menu from '../header/Menu/Menu';
import DesktopBanner from '../desktopBanner';
import { CommonLayoutProps } from '@/types/other';
import { useQueryClient } from '@tanstack/react-query';
import useHeaderQuery from '@/hooks/useHeaderQuery';
import useHeaderTranslation from '@/hooks/useHeaderTranslation';

const DashboardLayout = ({ children, user }: CommonLayoutProps) => {
  const queryClient = useQueryClient();
  const tHeader = useHeaderTranslation();
  const { userQuery, ctaCountQuery } = useHeaderQuery();
  return (
    <>
      <div>
        <DesktopBanner />
        <Header />
        <hr className="my-0 text-secondary max-nine:!tw-hidden" />
        <Container>
          <div className="tw-flex tw-items-stretch">
            <div className="tw-w-2/12 max-nine:tw-hidden">
              <Menu
                queryClient={queryClient}
                ctaCountQuery={ctaCountQuery}
                userQuery={userQuery}
                tHeader={tHeader}
              />
            </div>
            <div className="custom-border-start tw-w-10/12 tw-pb-20 max-nine:tw-w-full">
              {children}
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default DashboardLayout;
